module.exports = __webpack_public_path__ + "img/history11.0fb138d1.jpg";